import {SpacingXxlarge} from '@/componentLibrary/tokens/variables';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
    width: 720px;
    max-width: 100%;
    margin: ${SpacingXxlarge} auto 100px;
`;
